// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/foundations/typography.ts
export const fontSizes = {
  xl: '1.375rem',
}
